import React from 'react';
import image1 from '../../images/datawithSS.png';
import image2 from "../../images/article (2).png"
import image3 from "../../images/article (1).png"
// import image4 from "../../images/article (2).png"
import image5 from "../../images/article (3).png"
import HeroImage from "../../images/Rectangle 333 (1).png"
import { Link } from 'react-router-dom';
const SIDEBAR_ARTICLES = [
  {
    id: '1',
    type: 'EVENTS',
    typeColor: 'text-[#7BC216]',
    badgeText: 'Clean Transport',
    title: 'Netzence set to unveil clean mobility hailing App in June 2026',
    excerpt: 'At a time when Nigeria’s cities are expanding at an unprecedented pace, and the strain on urban systems',
    readTime: '5 mins read',
    date: '2/3/2026',
    bgImage: image1,
    link:"/blogpost"
  },
  {
    id: '2',
    type: 'ARTICLE',
    typeColor: 'text-[#7BC216]',
    badgeText: 'Lifestyle',
    title: 'Aligning Work and Sustainability Values',
    excerpt: 'Imagine getting up every day to work on something you value and believe in…How many of us can truly say we value what we do for a living, or that we are living by our values?',
    readTime: '7 mins read',
    date: '21/2/2026',
    bgImage: image2,
    link:"/articlePost6"
  },
  {
    id: '3',
    type: 'ADVERT',
    typeColor: 'text-[#099137]',
    badgeText: 'Circular Economy',
    title: 'Climate Reports Belong to the Public - Not the Shadows',
    excerpt: 'In an era marked by climate urgency, social inequity, and an ever-evolving investment landscape, the practice of',
    readTime: '4 mins read',
    date: '21/2/2026',
    bgImage: image3,
    hasOverlayImage: true,
    link:"/articlePost4"
  },
  {
    id: '4',
    type: 'ARTICLE',
    typeColor: 'text-[#7BC216]',
    badgeText: 'Sustainable farming',
    title: 'Common Design Reusable Packaging: Doing More with Less',
    excerpt: 'Most of the goods we consume come with some sort of packaging. While the goods are consumed, the',
    readTime: '5 mins read',
    date: '2/3/2026',
    bgImage: image5,
    link:"/articlePost3"
  }
];

export const ArticlePost1 = () => {
  return (
    <main className="w-full min-h-screen bg-white py-12 px-4 md:px-8 lg:px-0 font-sans selection:bg-[#7BC216]/20">
      {/* Frame 2147228719: Master Container */}
      <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-start gap-8 lg:gap-[32px]">
        
        {/* Frame 2147228721: Left Column (Main Content) */}
        <section className="w-full lg:w-[758px] flex-grow flex flex-col gap-[32px]">
          
          {/* Frame 2147228724: Main Image Banner */}
          <img 
            src={HeroImage}
            className="w-full h-[350px] sm:h-[450px] md:h-[612px] bg-cover bg-center rounded-[12px] shadow-sm transition-transform duration-300 hover:scale-[1.01]"
            alt="Climate Change Visual"
          />

          {/* Frame 2147228717 & 2147228715: Article Body */}
          <article className="w-full lg:max-w-[755px] flex flex-col gap-6 text-[#3B3B3B] text-[18px] leading-[28px] text-justify">
            <p className="font-normal">
              Average citizen that I am, I’d heard about climate change and wanted some accurate information about it. 
              Someone recommended the national climate assessments, so I looked for them. They were gone. What happened?
            </p>
            
            <p className="font-normal text-left">
              Blame the White House. They hid the national climate assessments which, according to NPR, are 
              “the most influential source of information about how climate change affects the United States.”
            </p>
            
            <p className="font-normal">
              Once upon a time, they were available on the official government website globalchange.gov. I tried to log on and got back, 
              “This site can’t be reached.” While the national climate assessments won’t go extinct - we hope - finding them might 
              resemble a scavenger hunt. NASA said the White House would host the reports. But despite a 1990 law, the Global Change 
              Research Act of 1990, which required them to do so, NASA has yet to. Contradicting the July 3 White House statement, 
              NASA said it won’t post the climate report to its website. There’s no legal obligation, it claims. Somewhere, this material 
              will continue to exist, but in light of the federal government’s current attitude, good luck finding it.
            </p>
            
            <p className="font-normal">
              These reports deserve far better than to languish in the dark corners of the internet. They should be broadcast across as 
              many computer screens as possible. It is vital that these reports be exposed to the country. Says Former Obama White House 
              science advisor and climate scientist John Holdren, national climate assessments are “useful to people who need to understand 
              what climate change is doing and will do to them, their loved ones, their property and their environment.”
            </p>
            
            <p className="font-normal">
              Peter Gleick, one of the authors of the first National Climate Assessment in 2000, called the White House action the 
              “modern version of book burning.” Another author, of four previous versions, said, “It’s information that I, as a scientist, 
              can say is absolutely critical to making good decisions for the future, whether you’re a farmer, a homeowner, a business owner, 
              a city manager, or anyone really who wants to ensure a safe and resilient future for themselves and for their children.”
            </p>
            
            <p className="font-normal">
              How do we keep this information from leeching away? Here’s a suggestion: add each national climate assessment to state government 
              websites. To County websites. To City websites. Feed them to schools, libraries, to your hometown press, to your social media. 
              Watch for updates and post them. Include the information in email blasts. The goal is to get this information into the hands of 
              as many as we can.
            </p>
            
            <p className="font-normal">
              This is not an original idea. In Europe, local and regional governments (LRGs) produce local action reports. But while they seek 
              peer-to-peer exchanges and access to finance, they don’t appear to be reaching out to the citizenry at large. What’s original is 
              boosting the activity into dozens of websites.
            </p>
            
            <p className="font-normal">
              In the United States, National Public Radio has announced where to find the national climate assessment. “An archived version 
              of the most recent edition is available through the National Oceanic and Atmospheric Administration. All five editions of the 
              National Climate Assessment that have been published over the years will also be available on NASA's website, according to NASA 
              spokesperson Bethany Stevens. But NASA doesn't yet know when that website will be available to the public.” An archived version 
              of the original, searchable website is available through the Internet Archive's Wayback Machine tool here. This is laudable, 
              but this is not enough. Not many will think about logging onto NOAH, NASA, or other less prominent government websites. 
              We need to spoon feed them the data.
            </p>
            
            <p className="font-normal mb-4">
              This action may not start a trend. It won’t spur everyone to action. It may catch the attention of no more than a few. 
              But think how many movements got their start from just a few.
            </p>

            {/* Frame 2147228718: Source footer */}
            <hr className="border-[#E4E7EC] my-2" />
            <div className="flex flex-col gap-[8px] text-left mt-2">
              <h4 className="font-bold text-[20px] text-[#3B3B3B] tracking-tight">Source</h4>
              <p className="font-normal text-[18px] text-[#3B3B3B]">
                Climate Reports Belong to the Public - Not the Shadows — Harvard ALI Social Impact Review
              </p>
            </div>
          </article>
        </section>

        {/* Frame 2147228689: Right Column (Sidebar Container) */}
        <aside className="w-full lg:w-[410px] flex flex-col gap-[32px] pt-4 lg:pt-0">
          <h2 className="text-[32px] font-bold text-[#141414] tracking-tight leading-[38px]">
            More Articles
          </h2>

          {/* Dynamic Render of Side Cards */}
          <div className="flex flex-col gap-[32px]">
            {SIDEBAR_ARTICLES.map((article) => (
              <Link 
              to={article.link}
                key={article.id}
                className="w-full bg-white border border-[#E4E7EC] rounded-[12px] overflow-hidden flex flex-col group hover:shadow-md transition-shadow duration-300"
                style={{ height: article.hasOverlayImage ? '536px' : '497px' }}
              >
                {/* Card Thumbnail Area */}
                <div className="w-full h-[289px] relative bg-slate-100 overflow-hidden border-b border-[#FAFAFA]">
                  <img 
                    src={article.bgImage} 
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                 
                </div>

                {/* Card Information Layout */}
                <div className="p-4 sm:p-6 flex flex-col flex-grow justify-between gap-4">
                  <div className="flex flex-col gap-[11px]">
                    {/* Top Badges */}
                    <div className="flex items-center gap-[8px]">
                      <span className={`text-[16px] font-medium tracking-wider uppercase ${article.typeColor}`}>
                        {article.type}
                      </span>
                      <span className="w-[6px] h-[6px] rounded-full bg-[#8D8484]" />
                      <div className="bg-[#3E3838] text-white text-[12px] font-normal px-[6px] py-[3px] rounded-[2px] leading-none">
                        {article.badgeText}
                      </div>
                    </div>

                    {/* Titles and Context Excerpts */}
                    <div className="flex flex-col gap-[8px]">
                      <h3 className="text-[20px] font-medium text-[#3B3B3B] leading-[24px] tracking-tight group-hover:text-[#7BC216] transition-colors line-clamp-2">
                        {article.title}
                      </h3>
                      <p className="text-[14px] text-[#898989] leading-[17px] line-clamp-2">
                        {article.excerpt}
                      </p>
                    </div>
                  </div>

                  {/* Footers */}
                  <div className="flex justify-between items-center border-t border-gray-50 pt-3 text-[#3B3B3B]">
                    <span className="text-[14px] font-medium uppercase text-xs tracking-wider">
                      {article.readTime}
                    </span>
                    <span className="text-[12px] font-medium text-[#B1B1B1]">
                      {article.date}
                    </span>
                  </div>
                </div>

              </Link>
            ))}
          </div>
        </aside>

      </div>
    </main>
  );
};

export default ArticlePost1